import React from 'react';
import { NOT_LOGGED_IN_USER_ID } from "../constants";
export const tokenContext = /*#__PURE__*/React.createContext({
  token: '',
  customerId: NOT_LOGGED_IN_USER_ID,
  formattedToken: '',
  isAnonymousUser: true
});
//# sourceMappingURL=tokenContext.js.map